import { useState, useEffect } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import formatDateTimeLocal from "../../../utils/formatDateTimeUtil";
import { CaseServices } from "../../../services/CaseServices";
import "./ReferenceDocDownload.scss";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
const ReferenceDocDownload = () => {
  const [loading, setLoading] = useState(false);
  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [startDate, setStartDate] = useState(formatDateTimeLocal(prevDate));
  const [endDate, setEndDate] = useState(formatDateTimeLocal(new Date())); //current date

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDocDownload = async () => {
    setLoading(true);
    try {
      const res = await CaseServices.downloadRefDocs(
        new Date(startDate),
        new Date(endDate)
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  return (
    <div className="reference-doc-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp;Download Reference
        Documents
      </span>
      <div className="heading">Download Reference Documents</div>

      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />
      <div className="flex justify-between">
        <div className="flex gap-3">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="datetime-local"
              id="start-date"
              // value={formatDate(startDate)}
              value={startDate}
              onChange={handleStartDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            <input
              type="datetime-local"
              id="end-date"
              // value={formatDate(endDate)}
              value={endDate}
              onChange={handleEndDateChange}
              max={formatDate(new Date())}
              style={{ border: "1px solid #E5E5E5" }}
              className="text-[#191919] appearance-none p-2 rounded-[8px] "
            />
          </div>
        </div>
        {loading ? (
          <CircularProgress />
        ) : (
          <div
            className="text-white bg-[#017C57] px-8 py-3 rounded-full cursor-pointer"
            onClick={handleDocDownload}
          >
            Download Ref Docs
          </div>
        )}
      </div>
    </div>
  );
};

export default ReferenceDocDownload;
